// Module
var code = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"12\" height=\"14\" stroke=\"none\"><path d=\"M6.8 0L0 8.556h6L5.2 14 12 5.444H6z\" fill-rule=\"evenodd\"/></svg> ";
// Exports
module.exports = code;